import { SessionProps } from "../types/SessionProps";

const Sessions: SessionProps[] = [
  {
    id: "001",
    title: "10：35〜11：45　口演①　［ 肝臓 ］（演題O-1〜O-3）",
    content: "",
    day: "1",
    link: "/session/001"
  },
  {
    id: "002",
    title: "13：15〜14：25　口演②　［ 胆道 ］（演題O-4〜O-6）",
    content: ``,
    day: "1",
    link: "/session/002"
  },
  {
    id: "003",
    title: "14：35〜16：05　プレナリーセッション1　［ 教育的・典型的症例 ］(演題PL-1〜PL-3）",
    content: ``,
    day: "1",
    link: "/session/003"
  },
  {
    id: "004",
    title: "16：15〜17：25　口演③　［ その他 ］(演題O-7〜O-9）",
    content: ``,
    day: "1",
    link: "/session/004"
  },
  {
    id: "005",
    title: "08：35〜09：45　口演④　［ 膵臓1 ］(演題O-10〜O-12）",
    content: ``,
    day: "2",
    link: "/session/005"
  },
  {
    id: "006",
    title: "13：15〜14：45　プレナリーセッション2　［ 教育的・典型的症例 ］(演題PL-4〜PL-6）",
    content: ``,
    day: "2",
    link: "/session/006"
  },
  {
    id: "007",
    title: "14：55〜16：05　口演⑤　［ 膵臓2 ］(演題O-13〜O-15）",
    content: ``,
    day: "2",
    link: "/session/007"
  },
  {
    id: "008",
    title: "16：15〜17：25　口演⑥　［ 膵臓3 ］(演題O-16〜O-18）",
    content: ``,
    day: "2",
    link: "/session/008"
  },
  {
    id: "009",
    title: "11：00〜11：50　ポスター口演　［ Poster 1 ］（P-1〜P-4）",
    content: ``,
    day: "3",
    link: "/session/009"
  },
  {
    id: "010",
    title: "11：00〜11：50　ポスター口演　［ Poster 2 ］（P-5〜P-8）",
    content: ``,
    day: "3",
    link: "/session/010"
  },
  {
    id: "011",
    title: "11：00〜11：50　ポスター口演　［ Poster 3 ］（P-9〜P-12）",
    content: ``,
    day: "3",
    link: "/session/011"
  },
  {
    id: "012",
    title: "11：00〜11：50　ポスター口演　［ Poster 4 ］（P-13〜P-15）",
    content: ``,
    day: "3",
    link: "/session/012"
  },
  {
    id: "013",
    title: "11：00〜11：50　ポスター口演　［ Poster 5 ］（P-16〜P-18）",
    content: ``,
    day: "3",
    link: "/session/013"
  },
  {
    id: "014",
    title: "11：00〜11：50　ポスター口演　［ Poster 6 ］（P-19〜P-21）",
    content: ``,
    day: "3",
    link: "/session/014"
  },
  {
    id: "015",
    title: "11：00〜11：50　ポスター口演　［ Poster 7 ］（P-22〜P-25）",
    content: ``,
    day: "3",
    link: "/session/015"
  },
  {
    id: "016",
    title: "11：00〜11：50　ポスター口演　［ Poster 8 ］（P-26〜P-28）",
    content: ``,
    day: "3",
    link: "/session/016"
  },
  {
    id: "017",
    title: "11：00〜11：50　ポスター口演　［ Poster 9 ］（P-29〜P-31）",
    content: ``,
    day: "3",
    link: "/session/017"
  },
  {
    id: "018",
    title: "11：00〜11：50　ポスター口演　［ Poster 10 ］（P-32〜P-34）",
    content: ``,
    day: "3",
    link: "/session/018"
  },
];

export default Sessions;
